import symbolsByGroup from './helpers/symbolsByGroup';
import trim from './helpers/trim';

// formatBirthdate и formatBirthdateMask для обратной совместимости
export { default as formatBirthdate } from './format/formatBirthdate';
export { default as formatBirthdateMask } from './format/formatBirthdate';
export * from './format/formatPhoneNumber';

export { default as transliterate } from './helpers/transliterate';
export { default as trim } from './helpers/trim';

const EMPTY_STR = '';
const SPACE_PAT = /\s/g;
export const SYMBOL_PAT = /[^a-zA-Zа-яА-ЯёЁ\s-]/g;
export const NON_SYMBOL_PAT = /[^A-ZА-Я-Ё|\s]/gim;
export const NON_LATIN_SYMBOLS_PAT = /[^a-z\s-]/gi;

export const NON_NUMBER_PAT = /\D/g;
export const ONLY_NUM_LETTER = /[^A-ZА-ЯЁ\d]/g;
export const NON_PASSPORT_PAT = /[^A-Z\d]/g;
export const NON_BIRTH_CERT_PAT = /[^a-zA-Zа-яА-ЯёЁ0-9]/gi;
export const NON_LATIN_AND_NUMBERS_PAT = /[^A-Za-z0-9']/g;

export const capitalize = (v) => (!v ? v : v[0].toUpperCase() + v.substr(1));
export const toUpperCase = (v) => (!v ? v : v.toUpperCase());
export const removeSpaces = (v) => (!v ? v : v.replace(SPACE_PAT, EMPTY_STR));
export const phoneNumber = (v) => (v ? v.replace(NON_NUMBER_PAT, EMPTY_STR) : v);
export const docType = (v) => (v ? v.toUpperCase().replace(ONLY_NUM_LETTER, EMPTY_STR) : v);

export const removeNonLetters = (v) => (!v ? v : v.replace(NON_SYMBOL_PAT, EMPTY_STR));
export const removeNonNumbers = (v) => (v ? v.replace(NON_NUMBER_PAT, EMPTY_STR) : v);
export const removeNonLatin = (v) =>
  v ? trim(v.toUpperCase().replace(NON_LATIN_SYMBOLS_PAT, EMPTY_STR)) : v;
export const removeNonBirthCertSymbols = (v) =>
  (v ? v.toUpperCase() : '').replace(NON_BIRTH_CERT_PAT, '');
export const removeNonLatinAndNumbers = (v) =>
  v ? v.replace(NON_LATIN_AND_NUMBERS_PAT, EMPTY_STR) : v;

export const translate = (v) => {
  if (!v) {
    return v;
  }

  return trim(
    v
      .toUpperCase()
      .replace(/./g, (CHAR) =>
        typeof symbolsByGroup.alpha[CHAR] !== 'undefined' ? symbolsByGroup.alpha[CHAR] : CHAR
      )
      .replace(SYMBOL_PAT, EMPTY_STR)
  );
};

export const switchLang = (v) => {
  if (!v) {
    return v;
  }

  return trim(
    v
      .toLowerCase()
      .replace(/./g, (CHAR) =>
        typeof symbolsByGroup.ruToEn[CHAR] !== 'undefined' ? symbolsByGroup.ruToEn[CHAR] : CHAR
      )
      .toUpperCase()
      .replace(SYMBOL_PAT, EMPTY_STR)
  );
};

export const enToRU = (v) => {
  if (!v) {
    return v;
  }

  return trim(
    v
      .toLowerCase()
      .replace(/./g, (char) => {
        return symbolsByGroup.enToRu[char] || char;
      })
      .replace(SYMBOL_PAT, EMPTY_STR)
  );
};

export const passportNumber = (v) => {
  if (!v) {
    return v;
  }

  return v
    .toUpperCase()
    .replace(/./g, (CHAR) =>
      typeof symbolsByGroup.alpha[CHAR] !== 'undefined' ? symbolsByGroup.alpha[CHAR] : CHAR
    )
    .replace(NON_PASSPORT_PAT, EMPTY_STR);
};
